import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const MaterialTransferAgreementRequired = ({ materialTransferAgreementRequired, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div id="materialTransferAgreementRequired" className="planField">
            <GroupApprovers />
            <FormControl>
                <FormLabel className="planRadioTitle" required={required.includes("materialTransferAgreementRequired")}>
                    {xplanLabels.materialTransferAgreementRequired}
                </FormLabel>
                <RadioGroup
                    name="materialTransferAgreementRequired"
                    label={xplanLabels.materialTransferAgreementRequired}
                    value={materialTransferAgreementRequired}
                    onChange={(e) => handleChange("materialTransferAgreementRequired", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"materialTransferAgreementRequired"} />}
        </div>
    );
};

export default MaterialTransferAgreementRequired;